// import core components
import Head from "next/head";
import type { AppProps } from "next/app";
import { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

// utils
import { GTMPageView } from "@/utils/gtm";

// import custom components
import Menu from "@/layout/Menu";

// import Footer from "@/layout/Footer";
const Footer = dynamic(() => import("@/layout/Footer"));

// import global styles
import "@/assets/styles/globalstyles.scss";

function MyApp({ Component, pageProps }: AppProps) {
  const [menuColor, setMenuColor] = useState("white");
  const router = useRouter();

  function renderFavIcon() {
    if (process.browser && window.matchMedia) {
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return <link rel="shortcut icon" href="../favicon-light.ico" />;
      } else {
        return <link rel="shortcut icon" href="../favicon-dark.ico" />;
      }
    }
  }

  useEffect(() => {
    const handleRouteChange = (url: string) => GTMPageView(url);
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  useEffect(() => {
    if (process.browser) {
      window["OneSignal"] = window["OneSignal"] || [];

      window["OneSignal"].push(function () {
        window["OneSignal"].SERVICE_WORKER_PARAM = { scope: "/" };
        window["OneSignal"].SERVICE_WORKER_PATH = "/OneSignalSDKWorker.js";
        window["OneSignal"].SERVICE_WORKER_UPDATER_PATH =
          "/OneSignalSDKUpdaterWorker.js";

        window["OneSignal"].init({
          appId: process.env.NEXT_PUBLIC_ONE_SIGNAL_ID,
          notifyButton: {
            enable: true,
          },
          allowLocalhostAsSecureOrigin: true,
        });
      });

      return () => {
        window["OneSignal"] = undefined;
      };
    }
  }, []);

  return (
    <>
      <Head>
        {renderFavIcon()}
        <script
          src="https://cdn.onesignal.com/sdks/OneSignalSDK.js"
          async={true}
        ></script>
      </Head>
      <Menu menuColor={menuColor} />
      <Component
        {...pageProps}
        menuOptions={{
          menuColor,
          setMenuColor,
        }}
      />
      <Footer />
    </>
  );
}

export default MyApp;
